/*
	参数	必填	说明
	appID	是	要拉起的appid
	extInfo	否	要拉起的appid时带的参数
	parameter	否	要拉起的appid时scheme信息
	showLaunchFailToast  否	默认为 true 是否会弹出启动失败的tips

	res.err_msg 
	{
		'err_msg':'launchApplication:ok',    	1、点击前往时，如果启动成功 2、如果点击了取消，也返回 ok
		'err_msg':'launchApplication:fail',		2、点击前往或者 前往不提示，只有前往失败才 返回此值。
	}
*/
import wxBridge from '../jsbridge/jsbridge_base.js';

import env from '../common/env.js';

wxBridge.launchApplication = wxBridge.launchApplication || function(param, callback) {
	var clientversion = env.clientVersion( true );
	if(env.versionCompare(clientversion,'6.5.5') >= 0){
		param = param || {};
		param.showLaunchFailToast = false;
		wxBridge.invoke('launchApplication', param, callback);	
	}else{
		wxBridge.invoke('launch3rdApp', param, function(res){
			res.err_msg = ( '' + res.err_msg ).replace('launch_3rdApp','launchApplication');
			callback && callback.call(wxBridge,res);
		});
	}	
};

export default wxBridge;

export const {
    launchApplication
} = wxBridge;
